(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["5am-event-countdown"] && !Shopify.designMode) return;
  try {
    
(function () {
  function initialiseEvent(section) {
    if (!section || section.dataset.fiveamInitialised === 'true') return;

    section.dataset.fiveamInitialised = 'true';

    var intro = section.querySelector('[data-event-intro]');
    var skip = section.querySelector('[data-skip-intro]');
    var reduceMotion = window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    function skipIntro() {
      section.classList.add('is-intro-skipped','is-intro-ended');

      if (intro) {
        intro.setAttribute('aria-hidden','true');
      }
    }

    if (skip) {
      skip.addEventListener('click',skipIntro);
    }

    if (intro) {
      intro.addEventListener('animationend',function (event) {
        if (
          event.target === intro &&
          event.animationName === 'fiveamEventIntroOut'
        ) {
          section.classList.add('is-intro-ended');
          intro.setAttribute('aria-hidden','true');
        }
      });
    }

    if (reduceMotion) {
      section.classList.add('is-intro-skipped','is-intro-ended');

      if (intro) {
        intro.setAttribute('aria-hidden','true');
      }
    } else {
      var userHasScrolled = false;
      var introStarted = false;
      var observer = null;

      function maybeStartIntro() {
        if (!userHasScrolled || introStarted) return;

        var rect = section.getBoundingClientRect();
        var viewportHeight =
          window.innerHeight ||
          document.documentElement.clientHeight ||
          800;

        if (
          rect.top < viewportHeight * .86 &&
          rect.bottom > viewportHeight * .14
        ) {
          introStarted = true;
          section.classList.add('is-in-view');

          window.removeEventListener('scroll',onScrollForIntro);

          if (observer) {
            observer.disconnect();
          }
        }
      }

      function onScrollForIntro() {
        if (window.scrollY > 8) {
          userHasScrolled = true;
        }

        maybeStartIntro();
      }

      if ('IntersectionObserver' in window) {
        observer = new IntersectionObserver(function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              maybeStartIntro();
            }
          });
        },{
          threshold: [.15,.25]
        });

        observer.observe(section);
        section._fiveamObserver = observer;
      }

      window.addEventListener('scroll',onScrollForIntro,{
        passive: true
      });

      section._fiveamIntroScrollHandler = onScrollForIntro;
    }

    var countdown = section.querySelector('[data-event-countdown]');
    var countdownModule = section.querySelector('[data-countdown-module]');
    var finished = section.querySelector('[data-event-finished]');
    var finalWindow = section.querySelector('[data-final-window]');
    var finalProgress = section.querySelector('[data-final-progress]');
    var target = Date.parse(section.getAttribute('data-event-date') || '');
    var finalWindowDays = 14;

    if (!Number.isFinite(finalWindowDays) || finalWindowDays < 1) {
      finalWindowDays = 14;
    }

    var finalWindowDuration = finalWindowDays * 86400000;

    function stopTimer() {
      if (section._fiveamTimer) {
        window.clearInterval(section._fiveamTimer);
        section._fiveamTimer = null;
      }
    }

    if (countdown && Number.isFinite(target)) {
      var days = section.querySelector('[data-days]');
      var hours = section.querySelector('[data-hours]');
      var minutes = section.querySelector('[data-minutes]');
      var seconds = section.querySelector('[data-seconds]');

      function updateCountdown() {
        var distance = target - Date.now();

        if (distance <= 0) {
          countdown.hidden = true;
          if (countdownModule) countdownModule.hidden = true;

          if (finished) {
            finished.hidden = false;
          }

          section.classList.remove('is-final-14-days');

          if (finalWindow) {
            finalWindow.hidden = true;
          }
          if (finalProgress) {
            finalProgress.hidden = true;
          }
          section.style.setProperty('--fiveam-final-progress','100%');

          stopTimer();
          return;
        }

        if (countdownModule) countdownModule.hidden = false;
        var isFinalWindow = distance <= finalWindowDuration;
        section.classList.toggle('is-final-14-days',isFinalWindow);

        if (finalWindow) {
          finalWindow.hidden = !isFinalWindow;
        }
        if (finalProgress) {
          finalProgress.hidden = !isFinalWindow;
        }
        if (isFinalWindow) {
          var progressPercent = Math.min(100,Math.max(0,(1 - distance / finalWindowDuration) * 100));
          section.style.setProperty('--fiveam-final-progress',progressPercent.toFixed(2) + '%');
        } else {
          section.style.setProperty('--fiveam-final-progress','0%');
        }

        function twoDigits(value) {
          return String(value).padStart(2,'0');
        }

        if (days) {
          days.textContent = twoDigits(Math.floor(distance / 86400000));
        }

        if (hours) {
          hours.textContent = twoDigits(
            Math.floor((distance % 86400000) / 3600000)
          );
        }

        if (minutes) {
          minutes.textContent = twoDigits(
            Math.floor((distance % 3600000) / 60000)
          );
                  }

        if (seconds) {
          seconds.textContent = twoDigits(
            Math.floor((distance % 60000) / 1000)
          );
        }
      }

      updateCountdown();

      if (target > Date.now()) {
        section._fiveamTimer = window.setInterval(updateCountdown,1000);
      }
    } else if (countdown) {
      countdown.hidden = true;
      if (countdownModule) countdownModule.hidden = true;
    }

    var bg = section.querySelector('.fiveam-event-bg');

    if (bg && !reduceMotion) {
      var ticking = false;

      function updateParallax() {
        var rect = section.getBoundingClientRect();
        var vh = window.innerHeight || 800;

        if (rect.bottom > 0 && rect.top < vh) {
          var progress = (vh - rect.top) / (vh + rect.height);

          bg.style.setProperty(
            '--fiveam-event-parallax',
            ((progress - .5) * -22).toFixed(2) + 'px'
          );
        }

        ticking = false;
      }

      function requestParallax() {
        if (!ticking) {
          window.requestAnimationFrame(updateParallax);
          ticking = true;
        }
      }

      window.addEventListener('scroll',requestParallax,{
        passive: true
      });

      window.addEventListener('resize',requestParallax,{
        passive: true
      });

      section._fiveamParallaxHandler = requestParallax;
      requestParallax();
    }
  }

  function initAll(scope) {
    if (
      scope &&
      scope.matches &&
      scope.matches('[data-fiveam-event]')
    ) {
      initialiseEvent(scope);
      return;
    }

    (scope || document)
      .querySelectorAll('[data-fiveam-event]')
      .forEach(initialiseEvent);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded',function () {
      initAll(document);
    });
  } else {
    initAll(document);
  }

  document.addEventListener('shopify:section:load',function (event) {
    initAll(event.target);
  });

  document.addEventListener('shopify:section:unload',function (event) {
    var target = event.target;

    var section =
      target && target.matches && target.matches('[data-fiveam-event]')
        ? target
        : target && target.querySelector
          ? target.querySelector('[data-fiveam-event]')
          : null;

    if (!section) return;

    if (section._fiveamTimer) {
      window.clearInterval(section._fiveamTimer);
    }

    if (section._fiveamObserver) {
      section._fiveamObserver.disconnect();
    }

    if (section._fiveamParallaxHandler) {
      window.removeEventListener('scroll',section._fiveamParallaxHandler);
      window.removeEventListener('resize',section._fiveamParallaxHandler);
    }

    if (section._fiveamIntroScrollHandler) {
      window.removeEventListener('scroll',section._fiveamIntroScrollHandler);
    }
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["header"]) return;
  try {
    
  class StickyHeader extends HTMLElement {
    constructor() {
      super();
      this.setHeaderHeight = this.setHeaderHeight.bind(this);
    }

    connectedCallback() {
      this.header = document.querySelector('.section-header');

      if (!this.header) return;

      this.mobileMediaQuery = window.matchMedia('(max-width: 990px)');

      this.headerIsAlwaysSticky =
        this.getAttribute('data-sticky-type') === 'always' ||
        this.getAttribute('data-sticky-type') === 'reduce-logo-size';

      this.headerBounds = {};

      this.setHeaderHeight();

      this.mobileMediaQuery.addEventListener('change', this.setHeaderHeight);

      if (this.headerIsAlwaysSticky) {
        this.header.classList.add('shopify-section-header-sticky');
      }

      this.currentScrollTop = 0;
      this.preventReveal = false;

      this.predictiveSearches = this.querySelectorAll('predictive-search');

      this.onScrollHandler = this.onScroll.bind(this);
      this.hideHeaderOnScrollUp = () => (this.preventReveal = true);

      this.addEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);

      window.addEventListener('scroll', this.onScrollHandler, false);

      this.createObserver();
    }

    setHeaderHeight() {
      if (!this.header) return;

      document.documentElement.style.setProperty(
        '--header-height',
        `${this.header.offsetHeight}px`
      );
    }

    disconnectedCallback() {
      this.mobileMediaQuery?.removeEventListener('change', this.setHeaderHeight);
      this.removeEventListener('preventHeaderReveal', this.hideHeaderOnScrollUp);
      window.removeEventListener('scroll', this.onScrollHandler);
    }

    createObserver() {
      const observer = new IntersectionObserver((entries, observer) => {
        this.headerBounds = entries[0].intersectionRect;
        observer.disconnect();
      });

      observer.observe(this.header);
    }

    onScroll() {
      const scrollTop = window.pageYOffset || document.documentElement.scrollTop;

      if ([...this.predictiveSearches].some((search) => search.isOpen)) return;

      if (scrollTop > this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');

        if (this.preventHide) return;

        requestAnimationFrame(this.hide.bind(this));

      } else if (scrollTop < this.currentScrollTop && scrollTop > this.headerBounds.bottom) {
        this.header.classList.add('scrolled-past-header');

        if (!this.preventReveal) {
          requestAnimationFrame(this.reveal.bind(this));
        } else {
          clearTimeout(this.isScrolling);

          this.isScrolling = setTimeout(() => {
            this.preventReveal = false;
          }, 66);

          requestAnimationFrame(this.hide.bind(this));
        }

      } else if (scrollTop <= this.headerBounds.top) {
        this.header.classList.remove('scrolled-past-header');
        requestAnimationFrame(this.reset.bind(this));
      }

      this.currentScrollTop = scrollTop;
    }

    hide() {
      if (this.headerIsAlwaysSticky) return;

      this.header.classList.add(
        'shopify-section-header-hidden',
        'shopify-section-header-sticky'
      );

      this.closeMenuDisclosure();
      this.closeSearchModal();
    }

    reveal() {
      if (this.headerIsAlwaysSticky) return;

      this.header.classList.add(
        'shopify-section-header-sticky',
        'animate'
      );

      this.header.classList.remove('shopify-section-header-hidden');
    }

    reset() {
      if (this.headerIsAlwaysSticky) return;

      this.header.classList.remove(
        'shopify-section-header-hidden',
        'shopify-section-header-sticky',
        'animate'
      );
    }

    closeMenuDisclosure() {
      this.disclosures = this.disclosures || this.header.querySelectorAll('header-menu');
      this.disclosures.forEach((disclosure) => disclosure.close());
    }

    closeSearchModal() {
      this.searchModals = this.searchModals || this.header.querySelectorAll('details-modal');
      this.searchModals.forEach((modal) => modal.close(false));
    }
  }

  if (!customElements.get('sticky-header')) {
    customElements.define('sticky-header', StickyHeader);
  }

  document.addEventListener(
    'open',
    (event) => {
      if (!(event.target instanceof HTMLElement) || !event.target.matches('shopify-account')) return;

      const bottom = Math.max(0, Math.round(event.target.getBoundingClientRect().bottom));
      event.target.style.setProperty('--account-dialog-top', `${bottom}px`);
    },
    true
  );

  } catch(e) { console.error(e); }
})();
})();
